const projectRegex = new RegExp(`^(${process.env.WEB_ROOT})/project/`)
const profileRegex = new RegExp(`^(${process.env.WEB_ROOT})/profile/`)
const templateRegex = new RegExp(`^(${process.env.WEB_ROOT})/start/(\\d+)\\??(.*)$`)

export default {
  fix: function (url) {
    if (url.indexOf('dropbox.com') >= 0) {
      const sep = url.indexOf('?') > 0 ? '&' : '?'
      url = `${url}${sep}raw=1`
    }

    url = url.replace(projectRegex, '$1/share/project/')
    url = url.replace(profileRegex, '$1/share/user/')
    url = url.replace(templateRegex, '$1/start/template?projectID=$2&$3')

    return url
  },

  isValid: function (urlstr) {
    let url
    try {
      url = new URL(urlstr)
    } catch (_) {
      return false
    }
    return url.protocol === 'http:' || url.protocol === 'https:'
  }
}
